import { post, parseData } from '../api/common';
import { responseHandler } from './api';
const getDataInterchanges = (IntegrationName = '') => post('/InternalAPI/DataInterchangeAPI.asmx/GetDataInterchangesByCompany', {
    IntegrationName
}).then(parseData);
const getDataInterchangeHistory = () => post('/InternalAPI/DataInterchangeAPI.asmx/GetDataInterchangeLogs').then(parseData);
const getDataInterchangeDirectories = async (dataInterchanges) => {
    const folderDataJSON = await post('/InternalAPI/DataInterchangeAPI.asmx/GetDataInterchangeDirectories', {
        DataInterchanges: dataInterchanges
    }).then(parseData);
    const folderData = JSON.parse(folderDataJSON.Data);
    return Promise.all(folderData.map(async (folder) => {
        const folderDataJSON = await post('/InternalAPI/FTPTodayAPI.asmx/GetFolderByPath', {
            Path: folder.Path
        }).then(parseData);
        if (Object.keys(JSON.parse(folderDataJSON.Data)).length > 0) {
            return {
                ...folder,
                Valid: true
            };
        }
        return {
            ...folder,
            Valid: false
        };
    }));
};
const getDataInterchangeFiles = async (dataInterchanges) => {
    const folderDataJSON = await post('/InternalAPI/DataInterchangeAPI.asmx/GetDataInterchangeDirectories', {
        DataInterchanges: dataInterchanges
    }).then(parseData);
    let folderData = JSON.parse(folderDataJSON.Data);
    // React treats false booleans as undefined, so we check for both.
    folderData = folderData.filter((f) => f.Internal === undefined || f.Internal === false);
    return Promise.all(folderData.map(async (folder) => {
        const fileDataJSON = await post('/InternalAPI/SFTPAPI.asmx/GetFilesInPath', {
            Path: folder.Path
        }).then(parseData);
        if (fileDataJSON.Status === 'success') {
            const fileData = JSON.parse(fileDataJSON.Data);
            return {
                ...folder,
                Files: fileData,
                Valid: true
            };
        }
        return {
            ...folder,
            Valid: false
        };
    }));
};
const saveDataInterchange = (dataInterchange) => {
    return post('/InternalAPI/DataInterchangeAPI.asmx/UpdateDataInterchange', {
        DataInterchange: dataInterchange
    }).then(parseData);
};
const runDataInterchange = (dataInterchangePK) => {
    return post('/InternalAPI/DataInterchangeAPI.asmx/QueueDataInterchangeByID', {
        InterchangeID: dataInterchangePK,
        EmpID: window.AccountConfig.Emp.PK
    }).then(parseData);
};
const moveSFTPFile = (filename, originalPath, newPath) => {
    return post('/InternalAPI/SFTPAPI.asmx/UpdateFile', {
        OriginalPath: originalPath,
        NewPath: newPath,
        OriginalFilename: filename,
        NewFilename: filename
    }).then(parseData);
};
const renameSFTPFile = (oldFilename, newFilename, path) => {
    return post('/InternalAPI/SFTPAPI.asmx/UpdateFile', {
        OriginalPath: path,
        NewPath: path,
        OriginalFilename: oldFilename,
        NewFilename: newFilename
    }).then(parseData);
};
const downloadSFTPFile = (filename, path) => {
    return post('/InternalAPI/SFTPAPI.asmx/GetFile', {
        Path: path,
        FileName: filename
    }).then(parseData);
};
const uploadSFTPFile = (filename, path, data) => {
    return post('/InternalAPI/SFTPAPI.asmx/CreateFile', {
        Path: path,
        FileName: filename,
        FileBase64: data
    }).then(parseData);
};
const getDataInterchangeTemplates = () => {
    return post('/InternalAPI/DataInterchangeAPI.asmx/ReturnDataInterchangeTemplates')
        .then(parseData)
        .then(responseHandler);
};
const saveTemplate = (Name, Data) => {
    return post('/InternalAPI/DataInterchangeAPI.asmx/SaveDataInterchangeTemplate', {
        Name,
        Data
    })
        .then(parseData)
        .then(responseHandler);
};
const getXMLValidation = (XML) => {
    return post('/InternalAPI/DataInterchangeAPI.asmx/ValidateXML', {
        XML
    })
        .then(parseData)
        .then(responseHandler);
};
export { downloadSFTPFile, getDataInterchanges, getDataInterchangeDirectories, getDataInterchangeFiles, getDataInterchangeHistory, moveSFTPFile, renameSFTPFile, runDataInterchange, saveDataInterchange, uploadSFTPFile, getDataInterchangeTemplates, getXMLValidation, saveTemplate };
